import Reflux from 'reflux';

/**
 * Actions for read only mode
 */
export default Reflux.createActions({
  clearShow: {},
});
